import { Component,  ChangeDetectorRef, ViewEncapsulation, ChangeDetectionStrategy, HostBinding,
   ViewChild, Input, AfterViewInit, AfterContentInit, ContentChild, OnInit, Output, ElementRef } from '@angular/core';
import { EventEmitter } from '@angular/core';

@Component({
  moduleId: module.id,
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',

  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class FileUploadComponent {
  @Input() uploadDisabled = false;

  @Output() upload: EventEmitter<any> = new EventEmitter();
  
  @ViewChild('fileInput', { static: true }) fileInput: ElementRef;
  @ViewChild('fileNameInput', { static: true }) fileNameInput: ElementRef;
  
  onUpload() {
    this.upload.emit(this.fileInput.nativeElement.files.item(0));
    this.fileNameInput.nativeElement.value = '';
    this.fileInput.nativeElement.value = '';
  }
  setFilename(event) {
    const file = event.target.files[0];
    const fileName = file != null ? file.name : null;
    this.fileNameInput.nativeElement.value = fileName;
  }
}
